import React from 'react';
import { Outlet, Link } from "react-router-dom";
import images from '../../helpers/images';
import helpers from '../../helpers/helpers';

function Header(){
    const home_url = helpers.getHomeURL();

    return (
        <>
            {/* <nav id="navbar" className="navbar navbar-expand-lg navbar-light bg-light fixed-top transition-3">
                <div className="container">
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-collapse">
                    <i className="fas fa-bars" />
                    </button>

                    <Link className="navbar-brand" to="/"><img src={images.mainLogoDark} alt="main-logo" /></Link>
                    <div id="navbar-collapse" className="collapse navbar-collapse">

                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item fw-bold">
                                <Link className="nav-link" to="/">Home</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav> */}
            
            <div id="top-header" className='fixed fixed-top transition-3'>
                <div className="container">
                    <div className="row align-items-center desktop-menu">
                        <div className="col-md-3">
                            <Link className="navbar-brand" to={home_url}><img src={images.mainLogoDark} alt="main-logo" /></Link>
                        </div>
                        <div className="col-md-6">
                            <ul className="top-menu">
                                {/* <li><Link to="/">Home</Link></li>
                                <li><Link to="faq">FAQ</Link></li>
                                <li><Link to="https://myspon.worldvision.org.ph/" target='_blank'>Myspon Portal</Link></li> */}
                            </ul>
                        </div>
                        <div className="col-md-3 header-cta-btn">
                            <Link className="orange-btn" to={home_url}>GIVE TODAY</Link>
                        </div>
                    </div>
                    <div className="row align-items-center mobile-menu">
                        <div className="col-12">
                            <a href="#" className="menu-icon">
                                <img src={images.burgerIcon} alt="menu-icon" />
                            </a>
                            <img src={images.mainLogoDark} alt="main-logo" className="wv-logo" />
                        </div>
                    </div>
                </div>
            </div>

            <Outlet />
        </>
    )
}

export default Header;